class Nav {
  constructor() {
    this.navigationWrapper = document.querySelector('#navigation-wrapper');
    this.navBar = document.querySelector('#navbar');
    this.navToggle = document.querySelector('#nav-toggle');
    this.menu = document.querySelector('#menu');
    this.menuItems = this.menu.querySelectorAll('.menu__item');
    this.links = this.menu.querySelectorAll('.menu__link');
    this.searchButton = document.querySelector('#search-button');
    this.open = false;
    this.timeoutInterval = 100;
    this.lastPageYOffset = 0;
    this.timeout;
    this.scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    this.focusableEls = this.navigationWrapper.querySelectorAll(
      'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'
    );
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
  }

  init() {
    this.navToggle.addEventListener('click', (e) => {
      e.preventDefault();

      if (!this.open) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    });

    document.addEventListener('keydown', (e) => {
      const handleBackwardsTab = () => {
        if (document.activeElement === this.firstFocusableEl) {
          e.preventDefault();
          this.lastFocusableEl.focus();
        }
      };

      const handleForwardsTab = () => {
        if (document.activeElement === this.lastFocusableEl) {
          e.preventDefault();
          this.firstFocusableEl.focus();
        }
      };

      const TAB_KEY = 9;
      const ESC_KEY = 27;

      if (!this.open) {
        return;
      }

      switch (e.keyCode) {
        case TAB_KEY:
          if (e.shiftKey) {
            handleBackwardsTab();
          } else {
            handleForwardsTab();
          }
          break;
        case ESC_KEY:
          this.closeMenu();
          break;
        default:
          break;
      }
    });

    this.lastPageYOffset = window.pageYOffset;

    if (this.lastPageYOffset > 0 + this.navBar.clientHeight) {
      this.hideNavbarScrolled();
    }

    window.addEventListener('scroll', (e) => {
      if (this.timeout) {
        window.cancelAnimationFrame(this.timeout);
      }

      this.timeout = window.requestAnimationFrame(() => {
        if (
          window.pageYOffset > this.lastPageYOffset &&
          window.pageYOffset > 0
        ) {
          // greater than 0 to fix Safari momentum scrolling issue
          // scrolled down (past the height of the navbar)
          this.hideNavbarScrolled();
          this.lastPageYOffset = window.pageYOffset;
        } else if (window.pageYOffset <= 0) {
          // reached the top
          this.returnNavbarToDefaultState();
          this.lastPageYOffset = window.pageYOffset;
        } else if (window.pageYOffset < this.lastPageYOffset - 50) {
          // 50px threshold
          // scrolled up but not at the top
          this.showNavbarScrolled();
          this.lastPageYOffset = window.pageYOffset;
        }
      });
    });

    for (let link of this.links) {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        const linkTarget = e.target.getAttribute('href');
        const currentUrl = window.location.pathname;

        if (currentUrl === linkTarget.split('#')[0]) {
          this.closeMenu();
          const targetEl = document.getElementById(linkTarget.split('#')[1]);
          if (targetEl) {
            if (targetEl.classList.contains('content-selector__item')) {
              //handle content selectors slightly differently
              window.location.hash = targetEl.id;
            } else {
              targetEl.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }
        } else {
          window.location.href = linkTarget;
        }
      });
    }
  }

  openMenu() {
    this.menu.classList.add('js-open');
    this.navToggle.classList.add('js-open');
    this.navToggle.setAttribute('aria-label', 'Close menu');
    this.navBar.classList.add('js-menu-open');
    this.searchButton.style.display = 'none';
    document.body.style.overflowY = 'hidden';
    document.body.style.paddingRight = `${this.scrollbarWidth}px`;
    for (let i = 0; i < this.menuItems.length; i++) {
      setTimeout(() => {
        this.menuItems[i].classList.add('js-open');
      }, (i + 1) * this.timeoutInterval);
    }
    this.open = true;
  }

  closeMenu() {
    this.navToggle.classList.remove('js-open');
    this.navToggle.setAttribute('aria-label', 'Open menu');
    this.navToggle.focus();
    for (let i = 0; i < this.menuItems.length; i++) {
      setTimeout(() => {
        this.menuItems[i].classList.remove('js-open');
      }, (i + 1) * this.timeoutInterval);
    }
    setTimeout(() => {
      this.menu.classList.remove('js-open');
      this.navBar.classList.remove('js-menu-open');
      this.open = false;
      this.searchButton.style.display = 'inline-block';
      document.body.style.overflowY = 'auto';
      document.body.style.paddingRight = 0;
    }, this.menuItems.length * this.timeoutInterval + this.timeoutInterval);
  }

  hideNavbarScrolled() {
    this.navBar.classList.remove('js-scroll-visible');
    this.navBar.classList.add('js-scroll-hidden');
  }

  showNavbarScrolled() {
    this.navBar.classList.remove('js-scroll-hidden');
    this.navBar.classList.add('js-scroll-visible');
  }

  returnNavbarToDefaultState() {
    this.navBar.classList.remove('js-scroll-hidden');
    this.navBar.classList.remove('js-scroll-visible');
  }
}

export default Nav;
